import React from 'react'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useEntity from './useEntity'
import { pageVars } from '../../../pages/const/pageVars'

const {codeText, headerText, showWarning, } = pageVars.ENTITIES

const pageSettings = {
  showWarning: showWarning || false,
  codeText: codeText || 'pageCodeText',
  headerText: headerText || 'pageHeaderText',
}

const ResourceSummary = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    page: 0,
    per_page: 20
  }
  const {
    loadEntities,
    bulkUpdateEntitysCallBack,
    typeIdToDisplayName,
    listEntityTypes
  } = useEntity()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper(
    pageSettings.codeText,
    bulkUpdateEntitysCallBack,
    pageSettings.showWarning
  )

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 200, sortable: true },
    {
      field: 'type',
      headerName: 'Type',
      width: 150,
      sortable: true
    },
    {
      field: 'total_contracts',
      headerName: 'Accounts',
      width: 150,
      sortable: true
    },
    {
      field: 'total_assets',
      headerName: 'Locations',
      width: 150,
      sortable: true
    },
    {
      field: 'total_datazones',
      headerName: 'Data Zones',
      width: 150,
      sortable: true
    },
    {
      field: 'total_operational_groups',
      headerName: 'Operational Groups',
      width: 150,
      sortable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 400,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 150,
      sortable: true
      //isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    // NOTE,
    // This is NOT how REACT is supposed to work. Due to the unfortunate
    // bad architecture of a previous UI team, we've had to do a bunch
    // of sub-optimal workarounds ahead of a rewrite.
    const [respEntities, entityTypes] = await Promise.all([
      loadEntities(arg),
      listEntityTypes()
    ])

    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = respEntities

    // transform the server-provided array for display
    const rows = []
    for (const one of data) {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        type: entityTypes.find(t => t.id === one.type_id)?.name,
        description: one.description,
        total_contracts: one.stats?.find(r => r.type === 'contracts')?.count,
        total_assets: one.stats?.find(r => r.type === 'assets')?.count,
        total_datazones: one.stats?.find(r => r.type === 'datazones')?.count,
        total_operational_groups: one.stats?.find(
          r => r.type === 'groups.operational'
        )?.count,
        active: one.suspended_at ? false : true
      })
    }

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={pageSettings.headerText}
          containedEntityType={'NA'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={[]}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            pageCodeText={pageSettings.codeText}
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
            showWarning={pageSettings.showWarning}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default React.memo(ResourceSummary)
